module.exports = __webpack_public_path__ + "img/a-propos.9084d42f.jpg";